// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router';
import Vant from 'vant';
import 'vant/lib/index.css';
// import './util/rem.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import common from './util/utils.js';
// import apiFun from "@/util/api.js";
// Vue.prototype.$apiFun = apiFun;//请求接口api
Vue.config.productionTip = false
Vue.prototype.common = common
Vue.use(Vant);

Vue.use(ElementUI);


router.beforeEach((to, from, next) => {
    // document.title = `契合科技 - ${to.meta.title} `;
    document.title = "契合科技" ;
    console.log("to", to);
    console.log("from", from);
    next()
});


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js